import * as React from 'react';

import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { IFormatter } from '../../../../../../../../Utils/Formatters/FormatterTypes';
import { ISortInfo } from '../../../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import EDTableCell from '../../../../../../../../BaseComponents/Table/Components/EDTableCell';
import EDTableHead from '../../../../../../../../BaseComponents/Table/Components/EDTableHead';
import EDTableRow from '../../../../../../../../BaseComponents/Table/Components/EDTableRow';
import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';
import EDTableSortLabel from '../../../../../../../../BaseComponents/Table/Components/EDTableSortLabel';
import EDTooltip from '../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import { IDetailRow } from '../EkonomiskAnalysDetailTable';

interface IProps {
  createSortHandler: (orderBy: string, caption: string) => () => void;
  hasPreliminaryData: boolean;
  headCells: IColumnHeader[];
  sortInfo: ISortInfo<IDetailRow>;
}

const useStyles = makeStyles()((theme: Theme) => ({
  cell: {
    padding: '4px 12px',
  },
  headerCell: {
    paddingBottom: '10px',
  },
  compactCell: {
    width: 12,
    paddingRight: 8,
    paddingLeft: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
  },

  verNrCell: {
    paddingRight: 16,
  },

  rightAlignText: {
    textAlign: 'end',
  },
}));

interface IColumnHeader {
  id: string;
  title1: string;
  title2: string | null;
  title3: string | null;
  formatter: IFormatter;
  isRightAligned: boolean;
  isVisible: boolean;
}

export const EkonomiskAnalysDetailTableHead: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes, cx } = useStyles();
  const { createSortHandler, headCells, sortInfo } = props;

  return (
    <EDTableHead>
      <EDTableRow>
        {headCells.map((headCell, index) => {
          const sortProperty = sortInfo.properties.find(
            x => x.orderBy === headCell.id
          );
          const sortIndex =
            sortInfo.properties.length > 1 &&
            sortInfo.properties &&
            sortProperty
              ? sortInfo.properties.indexOf(sortProperty) + 1
              : undefined;
          return (
            headCell.isVisible &&
            !(
              headCell.title1 === 'Definitivbokförd' &&
              !props.hasPreliminaryData
            ) && (
              <EDTableCell
                className={cx(classes.cell, classes.headerCell, {
                  [classes.rightAlignText]: headCell.isRightAligned,
                  [classes.compactCell]: headCell.title1 === 'Definitivbokförd',
                  [classes.verNrCell]: headCell.title1 === 'Vernr',
                })}
                key={headCell.id}
                onClick={createSortHandler(headCell.id, headCell.title1)}
              >
                {headCell.title1 === 'Definitivbokförd' &&
                  props.hasPreliminaryData && (
                    <EDTooltip title={'Inte definitivbokförda'}>
                      <EDTableSortLabel
                        active={Boolean(sortProperty)}
                        direction={
                          sortProperty ? sortProperty.order : undefined
                        }
                        sortIndex={sortIndex === 0 ? undefined : sortIndex}
                      >
                        <EDIcon
                          iconType="warning"
                          color="warning"
                          size="small"
                        />
                      </EDTableSortLabel>
                    </EDTooltip>
                  )}
                {headCell.title1 !== 'Definitivbokförd' && (
                  <EDTableSortLabel
                    active={Boolean(sortProperty)}
                    direction={sortProperty ? sortProperty.order : undefined}
                    sortIndex={sortIndex === 0 ? undefined : sortIndex}
                    onClick={createSortHandler(headCell.id, headCell.title1)}
                  >
                    {headCell.title1}
                  </EDTableSortLabel>
                )}
              </EDTableCell>
            )
          );
        })}
      </EDTableRow>
    </EDTableHead>
  );
};

export default EkonomiskAnalysDetailTableHead;
